const BaseView = require('./view');

module.exports = BaseView.extend({
    getAirportInfo(data) {
        return {
            departureCity: data.departure.cityIata,
            arrivalCity: data.arrival.cityIata,
        };
    },

});
